/**
 * @file DialogCrear.js
 * @brief Componente para crear una especialidad donde se solicita el nombre de la especialidad y la cantidad de consultas
 * @requires React
 */

import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from '@mui/material';
import toast from 'react-hot-toast';

const DialogCrearEspecialidad = ({ open, handleClose, handleCrear }) => {
  const [nombre, setNombre] = useState('');
  const [consultas, setConsultas] = useState('');

  const handleCrearEspecialidad = () => {
    if (!nombre || !consultas) {
      toast.error('Por favor, rellene todos los campos');
      return;
    }

    handleCrear({ nombre, consultas });
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '10px',
        }
      }}
    >
      <DialogTitle>Crear especialidad</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <TextField
            label='Nombre'
            variant='outlined'
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
          <TextField
            label='Consultas'
            variant='outlined'
            type='number'
            value={consultas}
            onChange={(e) => setConsultas(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleCrearEspecialidad}
        >
          Crear
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCrearEspecialidad;